
























import { Watch, Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class InputColorPalette extends Vue {
    @Prop({ default: null }) readonly rules!: string
    @Prop() readonly name!: string
    @Prop() readonly label!: string
    @Prop() readonly options!: string[]
    @Prop() readonly disabledOptions!: string[]
    @Prop({ type: Boolean, default: true }) readonly disabledOptionsChecked!: boolean
    @Prop() readonly value!: string
    @Prop({ type: Boolean, default: false }) readonly labelOutside!: boolean
    @Prop({ type: Boolean, default: false }) readonly disabled: boolean
    internalValue: string = null

    created() {
        this.onExternalChange()
    }

    @Watch('value')
    onExternalChange() {
        this.internalValue = this.value
    }

    @Watch('internalValue')
    onInternalChange(): void {
        this.$emit('input', this.internalValue)
    }

    get componentClass(): object {
        return {
            'input-color-palette': true,
        }
    }

    isSelected(option: string): boolean {
        return this.internalValue === option
    }

    isDisabled(option: string): boolean {
        return this.disabledOptions.includes(option)
    }
}
